import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  QueryList,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { LoyaltyCurrency, PointsAccount } from '@rd/types';
import { CardSelectComponent } from '../card-select/card-select.component';

@Component({
  selector: 'anz-card-carousel',
  templateUrl: './card-carousel.component.html',
  styleUrls: ['./card-carousel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardCarouselComponent implements AfterViewInit, OnDestroy {
  cardInFocus: number;
  @Input() pointsAccounts: PointsAccount[];
  @Input() defaultPointsAccountId: string;
  @Input() loyaltyCurrency: LoyaltyCurrency;

  @ViewChildren(CardSelectComponent)
  viewChildren!: QueryList<CardSelectComponent>;

  @ViewChild('container') carouselContainer: ElementRef;

  observer: IntersectionObserver;

  constructor(private cdRef: ChangeDetectorRef) {}

  ngAfterViewInit(): void {
    const options = {
      root: this.carouselContainer.nativeElement,
      rootMargin: '0px',
      threshold: 0.8,
    };
    this.observer = new IntersectionObserver(
      (entries: IntersectionObserverEntry[]) => {
        entries.forEach((entry: IntersectionObserverEntry) => {
          if (entry.isIntersecting) {
            this.cardInFocus = Number(entry.target.id);
            this.cdRef.detectChanges();
          }
        });
      },
      options,
    );
    this.viewChildren.forEach((element: CardSelectComponent) => {
      this.observer.observe(element.elementRef.nativeElement);
    });
  }

  ngOnDestroy(): void {
    this.viewChildren.forEach((element: CardSelectComponent) => {
      this.observer.unobserve(element.elementRef.nativeElement);
    });
    this.observer.disconnect();
  }
}
